import axiosInstance from './interceptor.tsx'

export enum UserType {
  BUYER = 'BUYER',
  ISSUER = 'ISSUER',
  NOT_VALID = 'NOT_VALID',
}

export interface UserTypeResponse {
  type: UserType
}

/**
 * Fetches the current user's type (buyer, issuer, or not valid)
 * @returns Promise with the user type response
 */
export const getUserType = async (): Promise<UserTypeResponse> => {
  const response = await axiosInstance.get<UserTypeResponse>('/auth/user-type')
  return response.data
}
